import { createSelector } from '@reduxjs/toolkit';
import { TriggerType } from 'client/voladeum/trigger-types/types';
import { RootState } from 'store';

const triggerTypesSlice = (state: RootState) => state.trigger_types;

export const selectTriggerTypes = createSelector(
  [triggerTypesSlice],
  (state): TriggerType[] => state
);
